export default "__VITE_ASSET__6cM4vyXq__"